export default {
  granularity: 'Granularidad',
  monthly: 'Mensual',
  quarterly: 'Trimestral',
  weekly: 'Semanal',
  week: 'Semana',
  missingTitle: 'Título faltante',
  jan: 'Ene',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Abr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Ago',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dic',
  q1: 'T1',
  q2: 'T2',
  q3: 'T3',
  q4: 'T4'
}
